(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name mapPairingGroups.service:mapPairingGroupsService
   *
   * @description
   *
   */
  angular
    .module('mapPairingGroups')
    .service('mapPairingGroupsService', mapPairingGroupsService);

  function mapPairingGroupsService(CommonMasterData,RemoteService) {
    var vm = this;

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDateStr : param.fromDate,
        toDateStr: param.toDate,
        fromTimeStr : param.fromTime,
        toTimeStr : param.toTime,
        airportCode: (param.airport !== null) ? param.airport.airPortCode : null,
        patternName:(param.pairingName !== null) ? param.pairingName :null
      };

      return actualSearchParam;
    }

    vm.searchMapPairingGroups = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchMapPairingGroups(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptUpdateRequset(param) {
      var identifierCodes = param.identifiers.map(function(a) {return  a.code;});
      var actualUpdateParam = {
        patternIds : param.patternIds,
        distributionIdentifier: identifierCodes.join(',')
      };

      return actualUpdateParam;
    }

    vm.updateIdentifiers = function (param ,successFn,errorFn) {
      var updateParam = adaptUpdateRequset(param);
      RemoteService.updateIdentifiers(updateParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

  }
}());
